// src/PublicEpkApp.tsx
//
// Minimal app shell for public EPK pages served at epk.bandjerry.com/{slug}.
// No React Router, no Amplify, no TanStack Query, no Zustand — just reads the
// slug from the URL path and renders the public page component.

import PublicEpkPage from '@/pages/PublicEpkPage';

function extractSlug(): string {
  // URL is epk.bandjerry.com/{slug} — strip leading slash
  const path = window.location.pathname;
  const slug = path.replace(/^\/+/, '').replace(/\/+$/, '');
  return slug;
}

export default function PublicEpkApp() {
  const slug = extractSlug();

  if (!slug) {
    // Root path with no slug — redirect to main site
    window.location.href = 'https://www.bandjerry.com';
    return null;
  }

  return <PublicEpkPage slug={slug} />;
}
